import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const getPropertyBuildingLevelsDone = (_, { payload }) => {
    return [
        ...payload
    ]
}

const initialState = [];

export default createReducer(initialState, {
    [TYPES.GET_BUILDING_LEVELS_DONE]: getPropertyBuildingLevelsDone
});